import { render, staticRenderFns } from "./BrowserLocPermissionSettings.vue?vue&type=template&id=c35129e4&scoped=true&"
import script from "./BrowserLocPermissionSettings.vue?vue&type=script&lang=js&"
export * from "./BrowserLocPermissionSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrowserLocPermissionSettings.vue?vue&type=style&index=0&id=c35129e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35129e4",
  null
  
)

export default component.exports